import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDeskOffice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"desk-office"} maskId="square-filled-radius-0-stroke-1-IconDeskOffice"><path fillRule="evenodd" clipRule="evenodd" d="M2 19V5H22V19H11V6H3V19H2ZM15 8H14V10H15V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDeskOffice;
